import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import classes from "./UIStyles.module.scss"
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const GenericModal = ({icon, title,fullscreen, bodyStyle, size="lg", ...props}) => {

    return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      size={size}
      fullscreen={fullscreen}
      {...props}
    >
      <Modal.Header className={classes.modalHeader}>
        <div className='w-100 d-flex '>
            <div>{icon}</div>
            <div style={{width:"100%", textAlign:"center"}}>
              {/* <PersonAddIcon style={{fontSize:"2.2rem", marginRight:"1rem"}}/> */}
              
              <span className={classes.modalTitleText}>{title}</span>
            </div>
            <div className="ms-auto">
              <HighlightOffIcon style={{fontSize:"2rem", cursor:"pointer"}} onClick={props.onHide}/>
            </div>
        </div>
      </Modal.Header>
      <Modal.Body className={classes.modalBody} style={bodyStyle}>
        {props.children}
      </Modal.Body>
    </Modal>
  );
}

export default GenericModal;

